@if (isBusy) {
  <app-modal-spinner></app-modal-spinner>
}

@if (project && projectEditForm) {
  <div class="hub-record-edit-container">
    <div class="record-edit-navs hub-custom-scrollbar">
      <ul class="section-list left" id="listRecordMenu"
        data-intro="Use the navigation to browse through the various property tabs for this record-type"
        data-step="4">
        <li data-view-setting="1" data-detail-panel="none" (click)="activateTab('summary')"
          [class.selected]="activeTab === 'summary'">
          <div class="media-body">
            <span class="link font-size-lg">Summary</span>
            @if (!isSummaryValid || !isProjectNameValid) {
              <span matTooltipShowDelay="500"
                matTooltip="This tab contains invalid data that must be corrected before the record can be saved.">
                <i class="icon-exclamation"></i>
              </span>
            }
          </div>
        </li>
        <li data-view-setting="1" data-detail-panel="none" (click)="activateTab('team')"
          [class.selected]="activeTab === 'team'">
          <div class="media-body">
            <span class="link font-size-lg">Team</span>
            @if (!isTeamValid) {
              <span matTooltipShowDelay="500"
                matTooltip="This tab contains invalid data that must be corrected before the record can be saved.">
                <i class="icon-exclamation"></i>
              </span>
            }
          </div>
        </li>
        <li data-view-setting="1" data-detail-panel="none" (click)="activateTab('location')"
          [class.selected]="activeTab === 'location'">
          <div class="media-body">
            <span class="link font-size-lg">Location</span>
            @if (!isLocationValid) {
              <span matTooltipShowDelay="500"
                matTooltip="This tab contains invalid data that must be corrected before the record can be saved.">
                <i class="icon-exclamation"></i>
              </span>
            }
          </div>
        </li>
        <li data-view-setting="1" data-detail-panel="none" (click)="activateTab('relations')"
          [class.selected]="activeTab === 'relations'">
          <div class="media-body">
            <span href="#" class="link font-size-lg">Relations</span>
          </div>
        </li>
        @if (project?.projectType?.name?.toLowerCase() === 'strategy') {
          <li data-view-setting="2" data-detail-panel="strategic-pillars" (click)="activateTab('strategic-pillars')"
            [class.selected]="activeTab === 'strategic-pillars'"
            >
            <div class="media-body">
              <span class="link font-size-lg">Strategic Pillars</span>
            </div>
          </li>
        }
        @if (!isProgramManagement && !isWholeSystem) {
          <li data-view-setting="2" data-detail-panel="outcomes"
            (click)="activateTab('outcomes')" [class.selected]="activeTab === 'outcomes'">
            <div class="media-body">
              <span class="link font-size-lg">Outcomes</span>
            </div>
          </li>
        }
        @if (!isProgramManagement && !isWholeSystem) {
          <li data-view-setting="2" data-detail-panel="int-results"
            (click)="activateTab('intermediate')" [class.selected]="activeTab === 'intermediate'">
            <div class="media-body">
              <span class="link font-size-lg">Intermediate Results</span>
            </div>
          </li>
        }
        <li data-view-setting="2" data-detail-panel="outputs" (click)="activateTab('outputs')"
          [class.selected]="activeTab === 'outputs'">
          <div class="media-body">
            <span class="link font-size-lg">Outputs</span>
          </div>
        </li>
        <li data-view-setting="1" data-detail-panel="none" (click)="activateTab('financials')"
          [class.selected]="activeTab === 'financials'">
          <div class="media-body">
            <span class="link font-size-lg">Financials</span>
            @if (!isFinancialsValid) {
              <span matTooltipShowDelay="500"
                matTooltip="This tab contains invalid data that must be corrected before the record can be saved.">
                <i class="icon-exclamation"></i>
              </span>
            }
          </div>
        </li>
        @if (!isProgramManagement) {
          <li data-view-setting="1" data-detail-panel="none" (click)="activateTab('attributes')"
            [class.selected]="activeTab === 'attributes'">
            <div class="media-body">
              <span class="link font-size-lg">Additional Information</span>
            </div>
          </li>
        }
        <li data-view-setting="1" data-detail-panel="none" (click)="activateTab('associatedFiles')"
          [class.selected]="activeTab === 'associatedFiles'">
          <div class="media-body">
            <span class="link font-size-lg">Associated Files</span>
          </div>
        </li>
      </ul>
    </div>
    <div class="record-edit-header" [formGroup]="projectEditForm" [ngClass]="{
            'project': project.projectType.name === 'Project',
            'strategy': project.projectType.name === 'Strategy',
            'hidden': isHeaderExpanded
        }">
      <div class="heading-item record-name">
        <div class="labl">{{project.projectType.name | titlecase}}</div>
        <div class="val">{{project.name}}</div>
      </div>
      <div class="heading-item divider"></div>
      <div class="heading-item">
        <div class="labl">{{project.projectType.name | titlecase}} ID</div>
        <div class="val">{{project.projectId}}</div>
      </div>
      <div class="heading-item divider"></div>
      <div class="heading-item record-status">
        <div class="labl">
          <span>Record Status</span>
          <mat-icon (click)="statusDropdown.open()">edit</mat-icon>
        </div>
        <mat-select #statusDropdown formControlName="statusId" hideSingleSelectionIndicator>
          @for (status of projectStatuses; track status) {
            <mat-option
            [value]="status.statusId">{{status.name}}</mat-option>
          }
        </mat-select>
      </div>
      <div class="heading-item record-actions">
        <a routerLink="/portfolio/{{ project?.projectId }}" matTooltip="View record" matTooltipShowDelay="500">
          <mat-icon>visibility</mat-icon>
          <span>VIEW RECORD</span>
        </a>
        <button (click)="saveProject()"
          [disabled]="projectEditForm.pristine || !isProjectValid || !isProjectNameValid"
          class="save-button  {{savingState}}" [ngClass]="{ invalid: !isValid }"
          [matTooltip]="getSaveButtonTooltip()" matTooltipShowDelay="500">
          <i class="icon-floppy-disk"></i>
          <i class="icon-spinner4"></i>
          <i class="icon-checkmark4"></i>
          <span>SAVE</span>
        </button>
      </div>
    </div>
    @if (project && projectEditForm) {
<div class="record-edit-header-expanded" [formGroup]="projectEditForm" [ngClass]="{
            'project': project.projectType.name === 'Project',
            'strategy': project.projectType.name === 'Strategy',
            'showing': isHeaderExpanded
        }">
        <div class="record-name">
          <div class="labl">{{project.projectType.name | titlecase}}</div>
          <div class="val">{{project.name}}</div>
        </div>
        <div class="record-info">
          <div class="project-id">
            <div class="labl">{{project.projectType.name | titlecase}} ID</div>
            <div class="val">{{project.projectId}}</div>
          </div>
          <div class="heading-item record-status">
            <div class="labl">
              <span>Record Status</span>
              <mat-icon (click)="statusDropdown2.open()">edit</mat-icon>
            </div>
            <mat-select #statusDropdown2 formControlName="statusId" hideSingleSelectionIndicator>
              @for (status of projectStatuses; track status) {
                <mat-option
                [value]="status.statusId">{{status.name}}</mat-option>
              }
            </mat-select>
          </div>
          <div class="heading-item record-actions">
            <a routerLink="/portfolio/{{ project?.projectId }}" matTooltip="View record" matTooltipShowDelay="500">
              <mat-icon>visibility</mat-icon>
              <span>VIEW RECORD</span>
            </a>
            <button (click)="saveProject()"
              [disabled]="projectEditForm.pristine || !isProjectValid || !isProjectNameValid"
              class="save-button  {{savingState}}" [ngClass]="{ invalid: !isValid }"
              [matTooltip]="getSaveButtonTooltip()" matTooltipShowDelay="500">
              <i class="icon-floppy-disk"></i>
              <i class="icon-spinner4"></i>
              <i class="icon-checkmark4"></i>
              <span>SAVE</span>
            </button>
          </div>
        </div>
      </div>
    }
    <div class="record-edit-body hub-custom-scrollbar">
      <div class="record-edit-component-panel">
        @switch (activeTab) {
          @case (projectTabs.summary) {
            <div class="p-3" style="position: relative;">
              <app-summary-edit></app-summary-edit>
              @if (canUserDeleteRecord()) {
                <button class="delete-record-button" (click)="deleteHubRecordRequested()" *ngIf="canUserDeleteRecord()">Delete Record</button>
              }
            </div>
          }
          @case (projectTabs.intermediate) {
            <app-intermediate-results-edit-container>
            </app-intermediate-results-edit-container>
          }
          @case (projectTabs.team) {
            <app-team-partners-edit-container></app-team-partners-edit-container>
          }
          @case (projectTabs.location) {
            <app-location-edit-container #locationEditContainer
            ></app-location-edit-container>
          }
          @case (projectTabs.relations) {
            <app-relations-edit-container></app-relations-edit-container>
          }
          @case (projectTabs.strategicPillars) {
            <app-strategic-pillars-edit-container>
            </app-strategic-pillars-edit-container>
          }
          @case (projectTabs.attributes) {
            <app-additional-information-edit-container
            ></app-additional-information-edit-container>
          }
          @case (projectTabs.outcomes) {
            <app-outcomes-edit-container></app-outcomes-edit-container>
          }
          @case (projectTabs.outputs) {
            <app-outputs-edit-container [projectTypeName]="project.projectType.name"
            ></app-outputs-edit-container>
          }
          @case (projectTabs.financials) {
            <app-financials-edit-container></app-financials-edit-container>
          }
          @case (projectTabs.associatedFiles) {
            <app-associated-files-edit-container>
            </app-associated-files-edit-container>
          }
        }
      </div>
    </div>
  </div>
}

@if (unauthorized) {
  <app-unauthorized [project]="project"></app-unauthorized>
}
